import React, { useRef, useEffect, useState } from 'react';
import {
  useDataProvider, Loading, Error, Title,
  useNotify
} from 'react-admin';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box, Button, IconButton
} from '@material-ui/core';
import {
  Adjust as AdjustIcon, 
  Save as SaveIcon, 
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon
} from '@material-ui/icons';

import { SET_FIRSTDATE } from '../customer-order';

import { 
  weekDays, getPrevWeekDay, getNextWeekDay, getYearMonthDate2
} from '../calendar';
import OrderCalendar from './OrderCalendar';
import { reqSchedules, reqSuggestion, reqSaveSchedule, reqUpdateSchedules } from './api';
import { downloadDailyCookOrders, downloadDailyDeliverySpecs, handleSchedulesResult, handleSuggestionsResult } from "./functions";
import {
  SET_ORDERS, SET_SUGGESTION, 
  selectOrders
} from './reducer';

const OrderList = (props) => {
  const dispatch = useDispatch();
  const dataProvider = useDataProvider();
  const notify = useNotify();

  const dataRef = useRef({ 
    schedules: [],
    orders: [],
  });

  // first date of current week 
  const [ dates, setDates ] = useState(weekDays(new Date()));

  // order schedules 
  const orders = useSelector(selectOrders);

  const [ loading, setLoading ] = useState(false);
  const [ loadingSave, setLoadingSave ] = useState(false);
  const [ error, setError ] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        // load order schedules 
        setLoading(true);
        const { data } = await reqSchedules(dataProvider, dates[0], dates.at(-1));

        // set order schedules 
        const newOrders = handleSchedulesResult(data);
        // dataRef.current.orders = newOrders;
        dataRef.current = {
          schedules: data, 
          orders: newOrders
        };
        dispatch({
          type: SET_ORDERS,
          payload: {
            orders: newOrders
          }
        });

        setLoading(false);
      }
      catch (err) {
        setError(err);
        setLoading(false);
        // LATER server logging  
        console.error(err);
      }
    }
    fetchData();

    // update firstDate of customer-order state
    dispatch({
      type: SET_FIRSTDATE,
      payload: {
        firstDate: dates[0]
      }
    });

  }, [ dates[0] ]);

  const handleClickPrev = () => {
    const prevDay = getPrevWeekDay(dates[0]);
    setDates(weekDays(prevDay));
  }

  const handleClickNext = () => {
    const nextDay = getNextWeekDay(dates[0]);
    setDates(weekDays(nextDay));
  }

  const handleClickCuration = async () => {
    try {
      // request curation 
      setLoading(true);
      const { data } = await reqSuggestion(dates[0], orders);
      dataRef.current.suggestions = data;

      // set order schedules 
      dispatch({
        type: SET_SUGGESTION,
        payload: {
          suggestions: handleSuggestionsResult(data)
        }
      });

      setLoading(false);
    }
    catch (err) {
      setError(err);
      setLoading(false);
      // LATER server logging 
      console.error(err);
    }
  }

  const handleClickSave = async () => {
    try {
      setLoadingSave(true);

      // filter not-changed 
      const orgOrders = dataRef.current.orders;
      const schedules = [];
      orders.forEach(o => {
        o.menu.forEach(m => {
          const customer = orgOrders.find(
            o2 => o2.customerId === o.customerId && o2.serviceTime === o.serviceTime);
          if (customer) {
            const menu = customer.menu.find(
              m2 => m2.id === m.id && m2.pickupTime !== m.pickupTime);
            if (menu) {
              schedules.push({
                id: m.id,
                pickupTime: m.pickupTime,
              });
            }
          }
        });
      });

      await reqUpdateSchedules(schedules);
      // update existing orders 
      dataRef.current.orders = orders;

      setLoadingSave(false);
    } catch (err) {
      setLoadingSave(false);
      notify(`저장에 실패했습니다. 관리자에게 문의해주세요. \n오류: ${err}`, 'error');
      console.error(err);
    }
  }

  const handleClickDownloadDeliveries = async (day) => {
    downloadDailyDeliverySpecs(orders, day);
  }

  const handleClickDownloadCookOrders = async (day) => {
    downloadDailyCookOrders(dataRef.current.schedules, day)
  }

  if (loading) return <Loading />;
  if (error) return <Error error={error} />;

  return (
    <div>
      <h1>
        스케쥴 캘린더
      </h1>
      <Box>
        <Box display="flex" flexDirection="row" justifyContent="space-between">
          <Box>
            <span>{getYearMonthDate2(dates[0]) + ' ~ ' + getYearMonthDate2(dates.at(-1))}</span>
            <IconButton 
              aria-label="go to prev"
              onClick={handleClickPrev}
            >
              <ChevronLeftIcon 
              />
            </IconButton>
            <IconButton 
              aria-label="go to next"
              onClick={handleClickNext}
            >
              <ChevronRightIcon 
              />
            </IconButton>
          </Box>
          <Box>
            <Button 
              variant="outlined"
              startIcon={<AdjustIcon />}
              onClick={handleClickCuration}
              disabled
            >
              큐레이션 실행
            </Button>
            <Button
              variant="outlined"
              onClick={handleClickSave}
              disabled={loadingSave}
              startIcon={<SaveIcon />}
              color="secondary"
            >
              저장하기
            </Button>
          </Box>
        </Box>
        <OrderCalendar
          date={dates[0]}
          orders={orders} 
          onClickDownloadDeliveris={handleClickDownloadDeliveries}
          onClickDownloadOrders={handleClickDownloadCookOrders}
        />
      </Box>
    </div>
  );
}


export default OrderList;